import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Navbar from "@/components/site/Navbar";
import { ARTICLES } from "@/lib/blog";

export default function Blog() {
  const scrollTo = () => {};
  return (
    <div className="min-h-screen bg-black">
      <Navbar onNavigate={scrollTo} />
      <main className="mx-auto max-w-[1400px] px-5 md:px-10 pt-36 pb-28">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }} className="mb-16 max-w-2xl">
          <p className="mb-6 text-xs uppercase tracking-mega text-gold">The Journal</p>
          <h1 className="font-serif font-light text-5xl md:text-7xl text-white tracking-tight leading-[0.9]">
            Boat-care <span className="text-gold-gradient italic">notes</span>
          </h1>
          <p className="mt-6 text-base md:text-lg font-light text-white/60 leading-relaxed">
            Practical detailing knowledge from the collective — protect your investment and get more from
            every season on the water.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {ARTICLES.map((a, i) => (
            <motion.div
              key={a.slug}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: i * 0.1 }}
            >
              <Link to={`/blog/${a.slug}`} className="group block" data-testid={`blog-card-${a.slug}`}>
                <div className="relative aspect-[4/3] overflow-hidden border border-white/10">
                  <img src={a.cover} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                </div>
                <div className="mt-5">
                  <p className="text-[11px] uppercase tracking-[0.2em] text-white/40">{a.date} · {a.readingTime}</p>
                  <h2 className="mt-3 font-serif text-2xl md:text-3xl text-white leading-tight group-hover:text-gold transition-colors">{a.title}</h2>
                  <p className="mt-3 text-sm font-light text-white/55 leading-relaxed">{a.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold">
                    Read <ArrowUpRight size={14} className="transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
                  </span>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </main>
    </div>
  );
}
